module.exports = __webpack_public_path__ + "img/GIF_ester.5778331e.gif";